<div class="ha-safety-section section-wrapper">
	<div id="lifestyle-safety">
		<div class="heading">
			<span [translate]="'wellness.health-assessment-new.lifestyle.safety.heading'">Safety</span>
		</div>
		<div class="form-group" [formGroup]="safetyForm">
			<div class="question-wrapper">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.safety.form-fields.sunscreen'">
					Do you wear sunscreen?
				</div>
				<div class="slider" *ngIf="safetySlider?.loaded">
					<div class="slider-labels">
						<span class="label-left">{{ safetyLookup[0]?.name }}</span>
						<span class="label-right">{{ safetyLookup[safetyLookup.length - 1]?.name }}</span>
					</div>
					<mat-slider
						appAutofocus
						[disabled]="readOnly"
						[max]="safetySlider.max"
						[min]="safetySlider.min"
						[step]="safetySlider.step"
						[showTickMarks]="true">
						<input matSliderThumb formControlName="wearSunscreen" />
					</mat-slider>
				</div>
			</div>
			<div class="question-wrapper">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.safety.form-fields.tanning'">
					Do you go tanning?
				</div>
				<div class="slider">
					<div class="slider-labels">
						<span class="label-left">{{ safetyLookup[0]?.name }}</span>
						<span class="label-right">{{ safetyLookup[safetyLookup.length - 1]?.name }}</span>
					</div>
					<mat-slider
						[disabled]="readOnly"
						[max]="safetySlider.max"
						[min]="safetySlider.min"
						[step]="safetySlider.step"
						[showTickMarks]="true">
						<input matSliderThumb formControlName="goTanning" />
					</mat-slider>
				</div>
			</div>
			<div class="question-wrapper">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.safety.form-fields.seatbelt'">
					Do you wear a seatbelt?
				</div>
				<div class="slider">
					<div class="slider-labels">
						<span class="label-left">{{ safetyLookup[0]?.name }}</span>
						<span class="label-right">{{ safetyLookup[safetyLookup.length - 1]?.name }}</span>
					</div>
					<mat-slider
						[disabled]="readOnly"
						[max]="safetySlider.max"
						[min]="safetySlider.min"
						[step]="safetySlider.step"
						[showTickMarks]="true">
						<input matSliderThumb formControlName="wearSeatbelt" />
					</mat-slider>
				</div>
			</div>
		</div>
	</div>
</div>
<div
	*ngIf="!readOnly"
	class="save-btn finish {{ readOnly ? 'read-only' : '' }}"
	appEheAnalytics
	[data]="analyticsData"
	(click)="next()">
	<button matStepperNext class="button button-medium" mat-button>
		<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-and-finish-button'"
			>Update and finish</span
		>
		<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.save-button'">Save and finish</span>
	</button>
</div>
